function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6667 29.3333C50.6667 19.0133 42.32 10.6667 32 10.6667C27.9129 10.6687 23.9397 12.014 20.6921 14.4955C17.4445 16.9769 15.1025 20.457 14.0267 24.4C10.7984 25.1421 7.91725 26.9571 5.85388 29.5484C3.79052 32.1397 2.66692 35.3542 2.66666 38.6667C2.66666 46.7733 9.22666 53.3333 17.3333 53.3333H49.3333C55.9733 53.3067 61.3333 47.92 61.3333 41.28C61.3333 35.0667 56.6667 30.0267 50.6667 29.3333ZM39.44 34.6667C40.64 34.6667 41.2267 36.1067 40.3733 36.9333L32.9333 44.3733C32.4 44.9067 31.5733 44.9067 31.04 44.3733L23.6 36.9333C23.4157 36.7453 23.2912 36.507 23.2422 36.2484C23.1931 35.9898 23.2217 35.7224 23.3244 35.48C23.4271 35.2376 23.5992 35.031 23.8191 34.8863C24.0389 34.7415 24.2968 34.6651 24.56 34.6667H29.3333V26.6667C29.3333 25.2 30.5333 24 32 24C33.4667 24 34.6667 25.2 34.6667 26.6667V34.6667H39.44V34.6667Z",
  fill: "black"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e114d182.svg";
export { ForwardRef as ReactComponent };